// extracted by mini-css-extract-plugin
export default {"layout":"layout___nI8pU","prompt":"prompt___EjJxn","passage":"passage___Iwn99","passageSource":"passageSource___TewFX"};